import ChecklistCreate from './create';
import ChecklistList from './list';
import ChecklistShow from './show';
import ChecklistEdit from './edit';

export default {
    create: ChecklistCreate,
    list: ChecklistList,
    show: ChecklistShow,
    edit: ChecklistEdit
};